<template>
  <div class="edit-user-form-wrapper">
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-4 col-lg-4 col-12">
          <div class="picture-upload-form text-center">
            <div class="picture-upload-form__header">
              <p class="text-secondary-orange font-semibold">Upload Picture</p>
            </div>
            <div class="my-3">
              <image-upload
                @input="handleImageUpload($event)"
                @remove-image="removeImage"
                :isUploadingImage="isUploadingImage"
              />
            </div>
          </div>
        </div>
        <div class="col-md-8 col-lg-8 col-12">
          <div class="edit-user-form__col-two__header">
            <p class="text-secondary-orange font-semibold">User Details</p>
          </div>
          <div class="input-row">
            <div class="edit-user-form__single-input-wrapper">
              <label for="firstname" class="label">First Name</label>
              <input type="text" class="input" v-model="user.firstName" />
            </div>
            <div class="edit-user-form__single-input-wrapper">
              <label for="middlename" class="label">Middle Name</label>
              <input type="text" class="input" v-model="user.middleName" />
            </div>
          </div>
          <div class="input-row">
            <div class="edit-user-form__single-input-wrapper">
              <label for="lastname" class="label">Last Name</label>
              <input type="text" class="input" v-model="user.lastName" />
            </div>
            <div class="edit-user-form__single-input-wrapper">
              <label for="gender" class="label">Gender</label>
              <el-select v-model="user.gender" placeholder="">
                <el-option
                  v-for="gender in genders"
                  :key="gender"
                  :label="gender"
                  :value="gender"
                >
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="input-row">
            <div class="edit-user-form__single-input-wrapper">
              <label for="email" class="label">Work Email</label>
              <input type="text" class="input" v-model="user.workEmail" />
            </div>
            <div class="edit-user-form__single-input-wrapper">
              <label for="number" class="label">Phone Number</label>
              <input type="text" class="input" v-model="user.phoneNumber" />
            </div>
          </div>
          <div class="input-row">
            <div class="edit-user-form__single-input-wrapper">
              <label for="employment-type" class="label">Employment Type</label>
              <el-select v-model="user.employmentType" placeholder="">
                <el-option
                  v-for="employmentType in employmentTypes"
                  :key="employmentType"
                  :label="employmentType"
                  :value="employmentType"
                >
                </el-option>
              </el-select>
            </div>
            <div class="edit-user-form__single-input-wrapper">
              <label for="role" class="label">Roles</label>
              <el-select v-model="user.roles" placeholder="">
                <el-option
                  v-for="role in roles"
                  :key="role.id"
                  :label="role.name"
                  :value="role.name"
                >
                </el-option>
              </el-select>
            </div>
          </div>
        </div>
      </div>
    </div>
    <hr />
    <advanced-details-form />
    <div class="button-wrapper">
      <button
        class="button button-secondary button-long"
        @click="$router.go(-1)"
      >
        Cancel
      </button>
      <button
        class="button button-primary button-long"
        :disabled="disableButton"
        @click="updateUser"
      >
        <button-loader v-if="updatingUser" />
        <span v-else>Update User</span>
      </button>
    </div>
  </div>
</template>

<script>
import AdvancedDetailsForm from "./AdvancedDetailsForm";
export default {
  components: {
    AdvancedDetailsForm,
  },
  data() {
    return {
      user: {
        firstName: "",
        middleName: "",
        lastName: "",
        gender: "",
        workEmail: "",
        phoneNumber: "",
        employmentType: "",
        roles: "",
      },
      genders: ["Male", "Female"],
      employmentTypes: [
        "Full-time",
        "Part-time",
        "Intern",
        "Company-paid Temporary",
        "Independent Contractor",
        "Agency-paid Temporary",
        "Vendor Employee",
        "Volunteer",
      ],
      updatingUser: false,
      roles: [],
      isUploadingImage: false,
    };
  },
  computed: {
    disableButton() {
      return this.shouldDisableButton(this.user);
    },
  },
  mounted() {
    this.getUserId();
  },
  methods: {
    async getUserDetails(userId) {
      try {
        let response = await this.$_getSingleUser(userId);
        console.log(response);
        this.saveUserDetails(response.data.groupuser);
      } catch (error) {
        this.handleError(error);
        console.log(error);
      }
    },
    saveUserDetails(user) {
      this.user.firstName = user.firstName;
      this.user.middleName = user.middleName;
      this.user.lastName = user.lastName;
      this.user.gender = user.gender;
      this.user.workEmail = user.workEmail;
      this.user.phoneNumber = user.phoneNumber;
      this.user.employmentType = user.employmentType;
      this.user.roles = user.roles;
      this.user.id = user.id;
    },
    async updateUser() {
      this.updatingUser = true;
      try {
        let response = await this.$_updateUser(this.user);
        console.log(response);
        this.generateToast("User successfully updated", "success");
        this.resetUser();
        this.$store.dispatch("resetUserList");
        setTimeout(() => {
          this.$router.push({ name: "UsersAndGroups" });
        }, 500);
      } catch (error) {
        this.handleError(error);
        this.updatingUser = false;
      }
    },
    getUserId() {
      let userId = localStorage.getItem("userId");
      if (userId) {
        console.log(userId);
        this.getUserDetails(userId);
      } else {
        this.$router.push({ name: "UsersAndGroups" });
      }
    },
    async getRoles() {
      try {
        let response = await this.$_getRoles();
        console.log(response);
        this.roles = response.data.roles;
      } catch (error) {
        this.handleError(error);
      }
    },
    onUpdateUser() {
      this.updatingUser = false;
      this.generateToast("User has successfully been created", "success");
      this.resetUser();
      this.$router.push("/settings/users-and-groups");
    },
    resetUser() {
      this.user = {
        firstName: "",
        middleName: "",
        lastName: "",
        gender: "",
        workEmail: "",
        phoneNumber: "",
        employmentType: "",
        roles: "",
      };
    },
    async handleImageUpload(image) {
      this.isUploadingImage = true;
      try {
        let response = await this.uploadImage(image);
        this.user.imageurl = response;
        // console.log("imageurl", response);
        this.isUploadingImage = false;
        this.generateToast("Image uploaded", "success");
      } catch (error) {
        this.handleError(error);
        this.isUploadingImage = false;
      }
    },
    removeImage() {
      this.user.imageurl = null;
    },
  },
};
</script>

<style scoped>
.edit-user-form-wrapper {
  margin: 2rem 0;
}
.picture-upload-form {
  border: 1px solid #edf2ef;
  border-radius: 10px;
  padding: 1.55rem 1rem;
}
.picture-upload-form__img-wrapper {
  position: relative;
}
.user-img {
  width: 10rem;
  margin: 1.5rem auto;
}
.upload-img-icon {
  position: absolute;
  right: 3.5rem;
  bottom: 1rem;
}
.picture-upload-form__meta {
  padding-top: 1rem;
}
.label {
  font-size: 0.9rem;
}
.input {
  margin-bottom: 0.5rem;
}
.edit-user-form__col-three {
  padding-top: 1.25rem;
}
hr {
  width: 60%;
  margin: 2rem auto;
}
.input-row {
  width: 100%;
  display: flex;
}
.input-row > div {
  width: 100%;
  padding-right: 1rem;
}
@media screen and (max-width: 768px) {
  .input-row {
    flex-direction: column;
  }
  .input-row div {
    width: 100%;
  }
}
</style>
